'use client';

export const ChevronLeft = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M11.1706 15.9979L22.6745 27.1443C22.8944 27.3572 23.0029 27.6131 22.9999 27.9122C22.9972 28.2114 22.8859 28.4675 22.6659 28.6804C22.4463 28.8935 22.182 29 21.8731 29C21.5644 29 21.3001 28.8935 21.0802 28.6804L9.69372 17.6397C9.45291 17.4064 9.27709 17.1463 9.16626 16.8593C9.05542 16.572 9 16.2849 9 15.9979C9 15.7109 9.05542 15.4237 9.16626 15.1365C9.27709 14.8495 9.45291 14.5893 9.69372 14.356L21.0891 3.31536C21.3088 3.10227 21.5716 2.99717 21.8775 3.00006C22.1835 3.00271 22.4463 3.11057 22.6659 3.32367C22.8859 3.53652 22.9958 3.79259 22.9958 4.09188C22.9958 4.39092 22.8859 4.64699 22.6659 4.86008L11.1706 15.9979Z"
				fill="currentColor"
			/>
		</svg>
	);
};
